export const styles = {
  display2: {
    fontSize: "26px",
    lineHeight: "32px",
    fontWeight: 800,
    color: "#404040",
    fontFamily: "MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif",
  },
};
